import { render } from "./radio_group.vue?vue&type=template&id=764a6af8&scoped=true"
import script from "./radio_group.vue?vue&type=script&lang=js"
export * from "./radio_group.vue?vue&type=script&lang=js"

import "./radio_group.vue?vue&type=style&index=0&id=764a6af8&scoped=true&lang=css"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764a6af8"]])

export default __exports__